import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Cacheable } from 'ngx-cacheable';

import { environment } from '../environments/environment';
import { TotemConfiguracion } from './totem-configuracion';

const cacheBuster$ = new Subject<void>();
@Injectable({
  providedIn: 'root'
})
export class TotemService {
  protected basePath = environment.apiURL;
  protected totemConfig: TotemConfiguracion = null;

  constructor(private http: HttpClient) { }

  async getTotemConfig(): Promise<TotemConfiguracion> {
    if ( ! this.totemConfig) {
      const path  = 'getTotem';
      const totem = environment.totem;
      const totemConfig = await this.http.post(this.basePath + path, { totem }).toPromise();
      this.totemConfig  = new TotemConfiguracion(totemConfig);
      console.log('configuracion ', this.totemConfig);
    }
    return this.totemConfig;
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getTiendas(): Observable<any> {
    const path   = 'getPuntosInteres';
    const params = {
      edificio: environment.edificio,
      canal   : environment.canal,
      idioma  : environment.idioma,
    };
    return this.http.post(this.basePath + path, params);
  }

  getTipoAccesos(): Observable<any> {
    const path   = 'getTipoAccesos';
    const params = {
      edificio: environment.edificio,
      canal   : environment.canal,
      idioma  : environment.idioma,
    };
    return this.http.post(this.basePath + path, params);
  }

  getAccesos(access): Observable<any> {
    const path   = 'getAccesos';
    const params = {
      edificio   : environment.edificio,
      tipo_acceso: access,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getCategorias(): Observable<any> {
    const path   = 'getCategorias';
    const params = {
      edificio: environment.edificio,
      idioma  : environment.idioma,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getPlanos(): Observable<any> {
    const path   = 'getPlanos';

    const params = {
      orientacion: this.totemConfig.orientacionId,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getNodos(): Observable<any> {
    const path   = 'getNodos';
    const params = {
      edificio: environment.edificio,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getRutaPi(): Observable<any> {
    const path   = 'getRutasPI';
    const params = {
      edificio: environment.edificio,
      totem   : environment.totem,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getRutasAccesos(): Observable<any> {
    const path   = 'getRutasAcc';
    const params = {
      edificio: environment.edificio,
      totem   : environment.totem,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getpublicidades(): Observable<any> {
    const path   = 'getPublicidad';
    const params = {
      edificio: environment.edificio,
      canal   : environment.canal
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  geteventos(): Observable<any> {
    const path   = 'getEventos';
    const params = {
      edificio: environment.edificio,
      idioma  : environment.idioma,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getPuntos(): Observable<any> {
    const path   = 'getPuntos';
    const params = {
      //edificio: environment.edificio,
      idioma  : environment.idioma,
    };
    return this.http.post(this.basePath + path, params);
  }

  isOpen = false;

  @Output() change: EventEmitter<boolean> = new EventEmitter();

  emitirReinicioTotem() {
    this.isOpen = !this.isOpen;
    this.change.emit(this.isOpen);
  }
}
